export default Object.freeze({
  // MEMBER_POPUP_
  MEMBER_NAME: '변경 대상회원',
  UPDATE_REASON: '변경 사유',
  REASON_HINT: '변경사유 입력',
  ALERT_REASON_NULL: '사유를 입력해 주세요.',
  ALERT_REASON_MAX: '글자수를 초과 하였습니다.',

  // Grade
  GRADE_TITLE: '회원등급 변경',
  MEBER_GRADE: '회원등급 선택',
  GRADE_HINT_1: '회원등급 혜택으로 설정 된 할인쿠폰이 발행 됩니다.',
  GRADE_HINT_2: '회원등급 수동변경은 다음 등급 변경일 전까지 유지됩니다.',
  ALERT_GRADE_NO_NULL: '회원 등급을 선택해 주세요.',
  GRADE_SUCCESS_MSG: '성공{0}건:회원등급 변경완료\r',
  FAIL_MSG: '실패{0}건:{1}',

  // Group
  GROUP_TITLE: '회원그룹 변경',
  MEBER_GROUP: '회원그룹 선택',
  UPDATE_TYPE: '추가/삭제 여부',
  ALERT_GROUP_NO_NULL: '회원 그룹을 선택해 주세요.',
  GROUP_SUCCESS_MSG: '성공{0}건:회원그룹 변경완료\r',

  // Accumulate
  ACCUMULATE_MEMBER: '지급 대상자',
  ACCUMULATE_A_D: '지급/차감',
  ACCUMLATE_PAYMENTS: '지급',
  ACCUMLATE_DEDUC: '차감',
  ACCUMLATE_DEDUCTION: '차감 (지급취소)',
  ACCUMLATE_PRICE: '금액',
  AMOUNT_PLACEHOLDER: '금액 입력',
  REASON_PLACEHOLDER: '변경사유 입력',
  PAYMENT_REASON: '지급 사유',
  VALIDITY_PERIOD: '유효기간 지정',
  VALIDITY_PERIOD_DEFAULT: '기본 유효기간에 따름',
  VALIDITY_PERIOD_CUSTOM: '별도 유효기간 지정',
  PERIODYMD_PLACEHOLDER: '유효기간 종료일 선택',
  ALERT_AMOUNT_NULL: '{0} 금액을 입력하세요.',
  ALERT_AMOUNT_ZERO: '0 은 {0} 할 수 없습니다.',
  ALERT_REASON_DETAIL_NULL: '사유를 입력하세요.',
  ALERT_PERIOD_YMD_NULL: '별도 유효기간을 지정해 주세요.',
  ACCUMULATE_SUCCESS_MSG: '성공 {count}건:{accumulateName} {accumulateStatus}완료\r',

  // GiveCoupon
  GIVE_COUPON_TITLE: '할인쿠폰 지급',
  SEARCH_TYPE: '검색어',
  SEARCH_TYPE_NAME: '쿠폰명',
  SEARCH_TYPE_NO: '쿠폰번호',
  TERM_ISSUE_START_YMD: '발행시작일',
  TERM_ISSUE_END_YMD: '발행종료일',
  TERM_REGISTER_YMD: '쿠폰등록일',
  ISSUE_TYPE: '쿠폰 발급 유형',
  ISSUE_TYPE_DOWNLOAD: '다운로드 발급',
  ISSUE_TYPE_CODE_DESIGNATE: '지정코드 발급',
  ISSUE_TYPE_CODE_RANDOM: '난수코드 발급',
  ISSUE_TYPE_INSERT: '인서트 발급',
  COUPON_TYPE: '혜택 구분',
  COUPON_TYPE_PRODUCT: '상품 금액 할인',
  COUPON_TYPE_CART: '장바구니 금액 할인',
  STATUS_TYPE_ISSUE_READY: '발급대기',
  STATUS_TYPE_ISSUE_ING: '발급 중',
  STATUS_TYPE_ISSUE_STOP: '발급중지',
  STATUS_TYPE_ISSUE_END: '발급종료',
  GIVE_COUPON_MEMBER: '지급 대상회원',
  GIVE_COUPON_MEMBER_BY_GRADE: '지급 대상 회원등급',
  REASON_PAYMENT: '지급사유',
  REASON_PAYMENT_PLACEHOLDER: '지급사유 입력',
  HEADER_COUPON_NO: '쿠폰번호',
  HEADER_STATUS_TYPE: '쿠폰상태',
  HEADER_COUPON_NAME: '쿠폰명',
  HEADER_COUPON_TYPE: '혜택구분',
  HEADER_ISSUE_TYPE: '발급유형',
  HEADER_ISSUE_START_YMDT: '발행 시작일',
  HEADER_ISSUE_END_YMDT: '발행 종료일',
  HEADER_REGISTER_ADMIN: '쿠폰 등록자',
  ERROR_SELECT_COUPON: '쿠폰을 선택해 주세요',
  ERROR_REASON_NULL: '지급사유를 입력하세요.',
  GIVE_COUPON_APPLY_CONFIRM: '할인쿠폰을 지급하시겠습니까?',
  GIVE_COUPON_CLOSE_CONFIRM: '쿠폰 지급을 취소하시겠습니까?',
  GIVE_COUPON_SUCCESS_MSG: '성공{0}건:할인쿠폰 지급완료\r',

  // MemberGradeEvaluation
  EVALUATION_TITLE: '회원등급평가설정',
  EVALUATION_USE_AUTOMATIC: '자동 등급평가 사용',
  EVALUATION_CONDITION_TYPE: '등급평가조건',
  EVALUATION_PERIOD: '평가기간',
  EVALUATION_PERIOD_SELECT: '기간선택',
  EVALUATION_PERIOD_HINT: '평가기간의 월말까지 조건기준으로 익월 등급조정 됩니다.',
  EVALUATION_VALID_PERIOD: '등급 유지기간',
  EVALUATION_DAY_OF_ADJUSTMENT: '등급 조정일',
  EVALUATION_DAY_EACH_MONTH: '매월',
  EVALUATION_DAY: '일',
  EVALUATION_DAY_OF_ADJUSTMENT_HINT: '설정한 등급 조정일 기준으로 적립금이 지급됩니다.',
  EVALUATION_DAY_OF_ADJUSTMENT_HINT_2: '수정한 등급 조정일은 다음 등급조정 시 적용됩니다.',
  EVALUATION_SAVE_CONFIRM: '변경 된 내용을 저장하시겠습니까?',
  EVALUATION_CLOSE_CONFIRM: '수정을 취소 하시겠습니까? 수정하신 내용은 저장되지 않습니다.',
  EVALUATION_OK_MSG1: '등급평가조건이 변경 되었습니다. 기존 등급평가조건으로 설정된 값에 문제 없는지 반드시 확인하시기 바랍니다.',
  EVALUATION_OK_MSG2: '변경사항이 저장 되었습니다.',

  ERR_INPUT_FORMAT: '입력형식이 잘못되었습니다.',

  // ProhibitMember
  HEADER_TITLE: '회원 이용정지',
  HEADER_TARGET_MEMBERS: '대상회원',
  HEADER_STOP_USING_DISTINCTION: '이용정지 구분',
  HEADER_SHUTDOWN: '정지기간',
  HEADER_STOPUSING_UNTIL_SPECIFIC_DATE: '특정날짜까지 이용정지',
  HEADER_PERMANENT_DISCONTINUATION_OF_USE: '영구이용 정지',
  HERDER_REASONS_FOR_DISCONTINUATION_OF_USE: '이용정지 사유',
  PLACE_HOLDER_ENTER_THE_REASON_TO_STOP_USING: '이용정지 사유 입력',
  HEADER_STOP_USING_NOTICE: '이용정지 알림',
  HEADER_CONTENT_OF_CUSTORMER_NOTICE: '고객알림 내용',
  PLACE_HOLDER_ENTER_CUSTOMER_NOTIFICATION_CONTENT: '고객 알림내용 입력',
  DATA_DISPLAY_STOP_USING: '이용정지',
  DATA_DISPLAY_RELIEVE_STOP: '이용정지 해제',
  DATA_DISPLAY_E_MAIL: 'e메일',
  DATA_DISPLAY_SEND_ALL: '모두 발송',
  PLACE_HOLDER_VALUE: '이용 정지 해제는 고객알림이 발송되지 않습니다.',
  ALERT_PLEASE_ENTER_THE_REASON_TO_STOP_USING: '이용정지 사유를 입력하세요.',
  ALERT_PLEASE_ENTER_THE_CONTENT_OF_CUSTOMER_NOTIFICATION: '고객 알림 내용을 입력하세요.',
  ALERT_ARE_YOU_SURE_YOU_WANT_TO_STOP_USING_IT: '이용정지를 진행하시겠습니까?',

  // GroupList
  GROUP_LIST_TITLE: '회원그룹',
	
	// 정보주체 외 개인정보 수집 시 알림 발송 가이드
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_TITLE: '정보주체 외 개인정보 수집 시 알림 발송 가이드',
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_CONTENT_1: '개인정보보호법',
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_CONTENT_2: '제20조 2항',
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_CONTENT_3:
		'에 따라 아래 기준에 해당하는 의무대상자의 경우 정보주체 외 개인정보 수집 시 개인정보의 수짐 출처, 처리목적, 처리정지 요구에 대한 권리가 있다는 사실을 정보주체에게 고지하여야합니다. <br />' +
		'- 5만 명 이상의 정보주체에 관하여 민감정보 또는 고유식별정보를 처리하는 자 <br />' +
		'- 100만 명 이상의 정보주체에 관하여 개인정보를 처리하는 자',
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_CONTENT_4:
		'간편 로그인 서비스를 통해 회원 가입 시 \'정보주체 외 개인정보를 수집\'한 경우에 해당하며, 의무대상자의 경우 관련 <br />' +
		'법령에 따라 수집 출처등을 고지하여야 합니다. <br />' +
		'위반 시 개인정보보호법',
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_CONTENT_5:
		'에 따라 3천만 원 이하의 과태료가 부과될 수 있습니다. <br />' +
		'필요한 조치를 취하지 않아 발생하는 불이익에 대하여 당사는 책임을 지지 않습니다.',
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_CONTENT_6:
		'간편 로그인 서비스를 이용 중이며, 의무대상에 해당할 경우 아래 자동발송 항목을 사용하여 수집 출처 등에 대한 고지가 가능합니다.',
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_CONTENT_7:
		'1. (SMS/이메일) \'회원가입 시 정보출처 고지\' <br />' +
		'- 해당 항목을 \'사용함\'으로 설정한 경우, 간편 로그인을 통해 회원가입 시 회원가입 시점에 알림 발송',
	NOTICE_TO_COLLECT_PERSONAL_INFORMATION_CONTENT_8:
		'2. (이메일) \'개인정보이용내역안내 (정보주체 외 개인정보 수집 시)\' <br />' +
		'- 해당 항목을 \'사용함\'으로 설정한 경우, 간편 <br />' +
		'로그인을 통해 가입한 회원의 개인정보이용내역 안내 주기(11개월)가 도래할 경우 수집출처등에 대한 고지항목이 포함된 템플릿으로 발송 <br />' +
		'- 간편 로그인을 통해 가입하지 않은 일반 쇼핑몰 회원에 대한 개인정보이용내역 알림 발송은 별도 항목(\'개인정보이용내역안내\')으로 제공',
});
